<div>
  <ul class="timeline">
    <li class="timeline__item" *ngFor="let item of shipment?.history">
      <div class="timeline__item__title font-H3">
        <p class="small">
          {{ "Enum.ShipmentStatus." + item.action | translate}}
          <span class="text-500 weight-normal">
            {{item.createdBy?.userType === UserType.DRIVER && (item.createdBy?.firstName && item.createdBy?.lastName) ? "("+
            ("Shipments.DriverAccepted" | translate) +")" : "("+ item.createdBy?.firstName +" "+ item.createdBy?.lastName +")"}}
          </span>
        </p>

        <p class="small" *ngIf="item.action != ShipmentAction.AssignDriver">
          <ng-container
            class="small"
            *ngIf="(item.action == ShipmentAction.ArrivePickupLocation || item.action == ShipmentAction.ArriveDropOffLocation)  && item.isAutomatedMobile == true"
          >
            ({{ "Enum.ShipmentStatus.AutomatedMobile" | translate}})
          </ng-container>
          <ng-container class="small" *ngIf="item.isAutomatedAVL == true">({{ "Enum.ShipmentStatus.Automated_AVL" | translate}})</ng-container>
        </p>
      </div>
      <span class="timeline__item__content font-H4 small">{{item?.createdAt | date : 'dd-MM-yyyy hh:mm aa'}}</span>
      <p
        *ngIf="item?.avlDistance &&
      item.action == ShipmentAction.AssignDriver ||
      item.action == ShipmentAction.AcceptDriver ||
      item.action == ShipmentAction.Start ||
      item.action == ShipmentAction.ArrivePickupLocation ||
      item.action == ShipmentAction.GoodsLoaded ||
      item.action == ShipmentAction.ArriveDropOffLocation ||
      item.action == ShipmentAction.GoodsDelivered"
        class="mt-0 small"
      >
        {{"Shipments.AvlDistance" | translate}}:
        <span class="timeline__item__content small">{{(+item?.avlDistance)?.toFixed(2)}} {{"Shipments.km" | translate}}</span>
      </p>

      <p
        class="small"
        *ngIf="shipment?.loadingOffTime &&
      item.action == ShipmentAction.ArrivePickupLocation"
      >
        {{"Shipments.WaitingTime" | translate}}:
        <span class="timeline__item__content text-warn small">{{loadingOffTime}}</span>
      </p>

      <p
        class="small"
        *ngIf="shipment?.droppingOffTime &&
      item.action == ShipmentAction.ArriveDropOffLocation"
      >
        {{"Shipments.WaitingTime" | translate}}:
        <span class="timeline__item__content text-warn small">{{droppingOffTime}}</span>
      </p>
    </li>
  </ul>
</div>
